/**
 * Enum para definir los tipos de loader HTML
 */
export enum LoaderType {
  /**
   * Loader de tipo esqueleto
   */
  Skeleton = 'skeleton'
}
